<!-- Form for subscription details -->
<!-- checking authorization -->
<ng-container *ngIf="role != 'CUSTOMER'">
  <h2 class="text-center">Unauthorised Access</h2>
</ng-container>
<!-- proceed if role is customer -->
<ng-container *ngIf="role === 'CUSTOMER'">
  <div class="page-wrapper bg-gra-01 p-t-45 p-b-50">
    <div class="wrapper wrapper--w790">
        <div class="card card-5">
                      <form #subsForm="ngForm" (ngSubmit)="subsForm.valid && onSubmit(subsForm)">
                        <div class="card-body">
                            <div class="form-row m-b-55">
                                <div class="value">
                                    <div class="row row-space">
                                        <div class="col">
                                          <label>Select Subscription Type</label>
                                          <select id = "myList" name="subType" #subType="ngModel" [(ngModel)]="subscriptionService.selectedSub.subType" required>
                                            <option value = "Monthly">Monthly</option>
                                            <option value = "Quarterly">Quarterly</option>
                                            <option value = "Half Yearly">Half Yearly</option>
                                            <option value = "Yearly">Yearly</option>
                                          </select>
                                            <div class="input-group-desc">
                                                <!-- <input class="input--style-5"
                                                    type="text" name="subType" #subType="ngModel" [(ngModel)]="subscriptionService.selectedSub.subType"
                                                    required
                                                    [ngClass]="{'invalid-textbox' :subsForm.submitted && !subType.valid }" style="border-radius: 15px;"
                                                > -->
                                                <div *ngIf="subsForm.submitted && subType.errors">
                                                    <label class="validation-message">
                                                        Subscription type is required
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                      </div>

                                </div>
                            </div>
                            <div>
                                <input type="submit" class="btn btn-primary" style="border-radius: 18px; position: left;" value="Subscribe"/>

                            </div>
                        </div>
                    </form>

            <!-- Error message -->
            <div class="alert" *ngIf="serverErrorMessages">
                {{serverErrorMessages}}
            </div>
        </div>
    </div>
</div>
</ng-container>
<!-- ENd of subscription form -->
